<template>
  <teleport to="body">
    <report-modal
      :show="!!reportModal"
      :resource="reportModal?.data?.resource"
      :resource-id="reportModal?.data?.resourceId"
      @close:report="clearGlobalModal"
    />

    <dependencies-modal
      :show="
        topModal?.modal === MODAL_DEPENDENCIES && !!topModal?.data?.dependencies
      "
      :mod-name-id="topModal?.data?.modNameId"
      :dependencies="topModal?.data?.dependencies"
    />

    <login-modal
      :show="!!loginModal"
      :has-close-btn="!loginModal?.data?.noAccess"
      :close-on-click-outside="!loginModal?.data?.noAccess"
      :close-on-escape="!loginModal?.data?.noAccess"
      @close:loginmodal="clearGlobalModal"
      @login:success="handleLogin"
    />

    <loading-modal
      :show="topModal?.modal === MODAL_LOADING"
      :status="topModal?.data?.status"
      :message="topModal?.data?.message"
      :button-text="topModal?.data?.buttonText"
    />

    <terms-modal
      :show="topModal?.modal === MODAL_AGREEMENT"
      :agreement-type="topModal?.data?.agreementType || 0"
      :back-button="globalModals.length > 1"
      @close:modal="handleCloseAgreement"
    />
  </teleport>
</template>

<script>
import { SS_REDIRECT } from '@config/localstorage.js'
import { defineAsyncComponent, computed } from 'vue'
import { getQueryFromPath } from '@helpers/utils.js'
import * as MODALS from '@config/globalModals.js'
import { useRoute } from '@composables'
import {
  clearGlobalModal,
  setGlobalModal,
  globalModals,
} from '@composables/useModal.js'

export default {
  components: {
    DependenciesModal: defineAsyncComponent(
      () => import('@components/Modals/DependenciesModal.vue')
    ),
    LoadingModal: defineAsyncComponent(
      () => import('@components/Modals/LoadingModal.vue')
    ),
    ReportModal: defineAsyncComponent(
      () => import('@components/Modals/ReportModal.vue')
    ),
    LoginModal: defineAsyncComponent(
      () => import('@components/Modals/LoginModal.vue')
    ),
    TermsModal: defineAsyncComponent(
      () => import('@components/Modals/TermsModal.vue')
    ),
  },
  setup() {
    const { push } = useRoute()

    const topModal = computed(() => globalModals.value.at(-1))

    const reportModal = computed(() =>
      globalModals.value.find((m) => m.modal === MODALS.MODAL_REPORT)
    )

    const loginModal = computed(() =>
      globalModals.value.find((m) => m.modal === MODALS.MODAL_LOGIN)
    )

    function handleLogin() {
      const redirectURL = sessionStorage.getItem(SS_REDIRECT)
      if (redirectURL) {
        const query = getQueryFromPath(redirectURL)
        sessionStorage.setItem(SS_REDIRECT, '')
        push({ path: redirectURL, query })
      }
    }

    function handleCloseAgreement() {
      const login = loginModal.value
      const report = reportModal.value

      clearGlobalModal()

      if (login || report) {
        setGlobalModal({
          modal: login ? MODALS.MODAL_LOGIN : MODALS.MODAL_REPORT,
          data: login ? login.data : report.data,
        })
      }
    }

    return {
      handleCloseAgreement,
      clearGlobalModal,
      globalModals,
      handleLogin,
      reportModal,
      loginModal,
      ...MODALS,
      topModal,
    }
  },
}
</script>
